import { H3, P } from "@upsolve/ui";
import get from "lodash/get";
import React from "react";
import AuthorsBlock, { TAuthor, TDateValue, TImageLoading } from "../Layout/AuthorsBlock";
import ArticleTile from "./ArticleTile.div";

type TArticleExcerpt = {
  articleExcerpt?: string | null;
} | null;

type TLearnArticle = {
  slug?: string | null;
  title?: string | null;
  createdAt?: TDateValue;
  updatedAt?: TDateValue;
  author?: TAuthor | null;
  authors?: TAuthor[] | null;
  articleExcerpt?: TArticleExcerpt;
};

type TLearnArticleTileProps = {
  article: TLearnArticle;
  imageLoading?: TImageLoading;
};

const LearnArticleTile = ({ article, imageLoading }: TLearnArticleTileProps): React.ReactElement => {
  const authors = (article.authors || [article.author]).filter((author): author is TAuthor =>
    Boolean(author && author.name != null)
  );
  const slug = article.slug || "";
  const title = article.title || "";
  return (
    <ArticleTile key={slug}>
      <div>
        <H3>
          <a href={`/learn/${slug}/`}>{title}</a>
        </H3>
        <AuthorsBlock
          authors={authors}
          createdAt={article.createdAt}
          updatedAt={article.updatedAt}
          imageLoading={imageLoading}
        />
        {get(article, "articleExcerpt.articleExcerpt") != null && (
          <P>{get(article, "articleExcerpt.articleExcerpt")}</P>
        )}
        <a href={`/learn/${slug}/`}>Read More →</a>
      </div>
    </ArticleTile>
  );
};

export default LearnArticleTile;
